<script>
  export let text;
</script>

<style lang="scss">
  @import '../../styles/settings/colors';

  .line-thru {
    display: block;
    font-size: 0.875em;
    margin-block-end: 1em;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 1;
    cursor: default;
  }

  .line-thru::before {
    width: 76px;
    height: 10px;
    background-color: $white;
    content: '';
    margin: -5px 0 0 -37px;
    left: 50%;
    position: absolute;
    top: 50%;
    z-index: -1;
  }

  .line-thru::after {
    border-block-end: 1px solid #dfe0e6;
    content: '';
    display: block;
    position: absolute;
    top: 49%;
    width: 100%;
    z-index: -2;
  }
</style>

<span class="line-thru">{text}</span>
